import React from 'react';
import WarframeTaskTracker from './WarframeTaskTracker';
import './App.css';

function App() {
  return (
    <div className="App">
      <WarframeTaskTracker />
    </div>
  );
}

export default App;